export function findPreviousTabbableElementOutsideRow(element: HTMLElement | null) {
  if (!element) return null

  const row = element.closest('li')
  if (!row?.contains(document.activeElement)) return null
  const elements = Array.from(
    document.querySelectorAll<HTMLElement>('a[href], button, input, select, textarea, [tabindex]'),
  ).filter(candidate => !candidate.closest('[inert]') && candidate.checkVisibility({visibilityProperty: true}))
  const elementIndex = elements.indexOf(element)
  if (elementIndex === -1) return null

  const isTabbable = (candidate: HTMLElement) => candidate.tabIndex >= 0 && !candidate.matches(':disabled')
  const previousTarget = elements
    .slice(0, elementIndex)
    .reverse()
    .find(candidate => isTabbable(candidate) && !row.contains(candidate))

  return (
    previousTarget ??
    elements.slice(elementIndex + 1).find(candidate => isTabbable(candidate) && !row.contains(candidate)) ??
    null
  )
}
